import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatDatepickerToggle } from '@angular/material/datepicker';
import { MatButton } from '@angular/material/button';
import {
  NgxMatDatepickerActions,
  NgxMatDatepickerApply,
  NgxMatDatepickerInput,
  NgxMatDatetimepicker
} from '@ngxmc/datetime-picker';
import { toLocalDate, toUTCString } from '../../../../../../../../config/date-adapter/date-formatter';
import { filter, Subscription, take, tap } from 'rxjs';

@Component({
  selector: 'app-date-range-filter',
  standalone: true,
  templateUrl: './date-range-filter.component.html',
  imports: [
    MatFormField,
    MatInput,
    MatDatepickerToggle,
    MatLabel,
    MatSuffix,
    ReactiveFormsModule,
    MatButton,
    NgxMatDatepickerActions,
    NgxMatDatepickerApply,
    NgxMatDatetimepicker,
    NgxMatDatepickerInput,
    MatError,
    FormsModule
  ],
  styleUrl: './date-range-filter.component.scss'
})
export class DateRangeFilterComponent implements OnChanges, OnDestroy {
  @Input() paramsGroup!: FormGroup;

  from: Date | null = null;
  to: Date | null = null;

  private subscription = new Subscription();

  ngOnChanges(changes: SimpleChanges) {
    if (changes['paramsGroup']) {
      this.subscription.add(
        this.paramsGroup.valueChanges
          .pipe(
            filter(({ from, to }) => Boolean(from) && Boolean(to)),
            take(1),
            tap(({ from, to }) => {
              this.from = toLocalDate(from);
              this.to = toLocalDate(to);
            })
          )
          .subscribe()
      );
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  setValue(controlName: string, dateTime: Date) {
    this.paramsGroup?.get(controlName)?.setValue(toUTCString(dateTime));
  }
}
